import { GetServerSideProps } from 'next';
import { CMSPageResponse, HtmlDocPageData, MenuResponse } from 'types';
import { getMenuData, getPageData } from 'api';
import { getCommonOgData, getPageDescription, getPageH1Title } from 'utils/seoFormatters';
import { getCanonicalUrlFromContext } from 'utils/formatters';
import { HtmlDocPage } from 'containers/HtmlDocPage';

const TermsOfUsePage = (props: any) => {
  return <HtmlDocPage {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const force = !!context.query.force;
  const menuDataRequest: Promise<MenuResponse> = getMenuData(force);
  const pageDataRequest: Promise<CMSPageResponse<HtmlDocPageData>> = getPageData('privacy-policy', force);

  const [menuData, pageData] = await Promise.all([menuDataRequest, pageDataRequest]);

  return {
    props: {
      menuData,
      pageData: pageData.content,
      headTitle: 'Privacy Policy | SENDY',
      title: 'SENDY Privacy Policy',
      ogData: getCommonOgData({
        url: getCanonicalUrlFromContext(context),
        title: 'Privacy Policy | SENDY',
        description: getPageDescription('privacyPolicy'),
      }),
      seoHiddenProps: {
        title: getPageH1Title('privacyPolicy'),
      },
    },
  };
};

export default TermsOfUsePage;
